/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
import type { TranslationKey } from '../models/TranslationKey';

export type DefaultTranslations = Record<keyof typeof TranslationKey, string>;

export const defaultTranslations: DefaultTranslations = {
  buy: 'Buy',
  choose: 'Choose',
  goBack: 'Go back',
  lowestPrice: 'Our lowest price, the last 30 days before current price, was',
  mrpStatement: 'Inclusive of all taxes',
  productIsDiscontinued: 'Product is discontinued',
  productIsDiscontinuedDescription: 'The product you are looking for has been discontinued and is no longer for sale.',
  productNotFound: 'Product not found',
  productNotFoundDescription: 'We are experiencing technical difficulties and the product cannot be found.',
  replace: 'Replace',
  replaceWith: 'Replace with',
  reserve: 'Reserve',
  save: 'Save',
  subscribe: 'Subscribe',
};

export const translationsNamespace = 'product-info-dialog';
